import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface ContractSection {
  id: number;
  name: string;
  content: string; // HTML string
  contentDelta?: any; // Quill Delta object (optional)
}

@Injectable({
  providedIn: 'root',
})
export class ContractSectionsService {
  private baseUrl = `${environment.backofficeApiUrl}/v1/api`;
  private sections: ContractSection[] = [];
  private nextId = 1;
  
  // Subject per comunicare la richiesta di creazione di un nuovo blocco
  private newBlockRequestSubject = new Subject<void>();
  public newBlockRequest$ = this.newBlockRequestSubject.asObservable();

  constructor(private http: HttpClient) {}
  
  // Metodo per richiedere la creazione di un nuovo blocco
  requestNewBlock(): void {
    this.newBlockRequestSubject.next();
  }

  getAll(): Observable<ContractSection[]> {
    return this.http.get<ContractSection[]>(`${this.baseUrl}/sections`);
  }

  getById(id: number): Observable<ContractSection> {
    return this.http.get<ContractSection>(`${this.baseUrl}/sections/${id}`);
  }

  create(section: { name: string; content: string; contentDelta?: any }): Observable<ContractSection> {
    return this.http.post<ContractSection>(`${this.baseUrl}/sections`, section);
  }

  update(id: number, section: Partial<ContractSection>): Observable<ContractSection> {
    return this.http.put<ContractSection>(`${this.baseUrl}/sections/${id}`, section);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/sections/${id}`);
  }

  generateWord(name: string, content: string, contentDelta: any): Observable<Blob> {
    const payload = {
      name,
      content,
      contentDelta,
    };
    return this.http.post(`${this.baseUrl}/generate-word`, payload, {
      responseType: 'blob',
    });
  }

  generatePdf(name: string, content: string, contentDelta: any): Observable<Blob> {
    const payload = {
      name,
      content,
      contentDelta,
    };
    return this.http.post(`${this.baseUrl}/generate-pdf`, payload, {
      responseType: 'blob',
    });
  }
}
